<!--
  画面名：食材データ入力画面
  概要： 雛形の食材と事業者の食材を登録、編集、削除をするコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <div class="wrapper">
    <v-toolbar flat color="white">
      <PageTitle :PageTitle="pageTitle" />
      <v-spacer />
        <!-- 計画書一覧画面へ戻るボタン/文書雛形遷移ボタン。isPlanがtrueの時は計画書一覧画面へ戻る。falseの時は文書雛形遷移。 -->
        <v-btn v-if="isPlan" class="btn" @click="toPlanFormulation" small>{{$language.LabelBack}}</v-btn>
        <v-btn v-else @click="toTemplateList" class="btn" small>{{$language.LabelTemplateDocument}}</v-btn>
        <!-- 追加ボタン -->
        <v-btn @click="addFoodDialog" small class="btn" v-if="isAuth">
          {{ $language.LabelAdd }}
        </v-btn>
    </v-toolbar>
    <!-- 食材データテーブル -->
    <FoodDataList
      @checkSelection="checkSelection"
      @allergenDialog="allergenDialog"
      @editDialog ="editDialog"
      ref="FoodDataList"
      :isPlan="isPlan"
      :isAuth="isAuth"
    />
    <!-- ダイアログ表示用コンポーネント読込 -->
    <Dialog
      ref="Dialog"
      :isPlan="isPlan"
      @foodDataReload="foodDataReload"
    />
  </div>
</template>
<!-- /HTML -->

<script>
// 子（外部）コンポーネント読み込み
// ページタイトル
import PageTitle from '@/components/parts/common/PageTitle'
// 食材データテーブル
import FoodDataList from '@/components/parts/common/FoodDataList'
// ダイアログ表示用コンポーネント読込
import Dialog from '@/components/parts/common/Dialog'

export default {
  // 親ページのデータを取得
  props: {
    // ページタイトル
    pageTitle: String,
    // 計画書か判定するフラグ
    isPlan: { type: Boolean, default: false },
    // 権限の判定（店舗責任者）
    isAuth: { type: Boolean, default: true }
  },
  // 使用コンポーネント
  components: {
    // ページタイトル
    PageTitle,
    // 食材データテーブル
    FoodDataList,
    // ダイアログ
    Dialog
  },

  // コンポーネント内の変数を定義
  data () {
    return {
      // 子コンポーネントのリストボックスで選択されている文字列を格納
      select: ''
    }
  },
  // 関数郡
  methods: {
    // 戻るボタンが押下された際に発火。計画策定選択画面に遷移
    toPlanFormulation () {
      this.$router.push({ name: 'PlanFormulation' })
    },
    // 文書雛形へ遷移
    toTemplateList () {
      this.$router.push({ name: 'TemplateList' })
    },
    // 選択されている種別をチェックする
    checkSelection (value) {
      this.select = value
    },
    // アレルゲンが押下された時に発火
    allergenDialog (value) {
      // ダイアログ内に表示するコンポーネントを決める
      this.$refs.Dialog.changeView('isAllergen')
      // 編集する食材データをダイアログコンポーネントに送る
      this.$refs.Dialog.getAllergenData(value)
    },
    // 食材データ編集ダイアログ
    editDialog (value) {
      // ダイアログ内に表示するコンポーネントを決める
      this.$refs.Dialog.changeView('isEditFood')
      // 編集する食材データをダイアログコンポーネントに送る
      this.$refs.Dialog.getEditData(value)
    },
    // 食材データ追加ダイアログ
    addFoodDialog () {
      this.$refs.Dialog.changeView('isAddFood')
      // 編集する食材データをダイアログコンポーネントに送る
      this.$refs.Dialog.deleteEditData()
    },
    // DBから食材データを再取得する
    foodDataReload () {
      this.$refs.FoodDataList.getFoodData()
    }
  }
}
</script>
